module.exports = __webpack_public_path__ + "static/img/bei-computer.f88e5ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bei-computer.png
// module id = E+V1
// module chunks = 0